import React from "react"
import { ShopifyImage } from "./ShopifyImage"
import { GatsbyImageComponent } from "./GatsbyImageComponent"

export const Image = ({
  alt = "",
  location = undefined,
  cover = undefined,
  onClick = undefined,
  ratio = undefined,
  image = undefined,
  fullHeight = undefined,
  fullWidth = undefined,
  hoverImage = undefined,
  maxWidth = undefined,
  imageLink = undefined,
  styled = undefined,
  objectFit = undefined,
  background = undefined,
  staticImage = false,
  loading = undefined,
}) =>
  typeof image === `string` ? (
    <ShopifyImage
      alt={alt || ""}
      onClick={onClick}
      ratio={ratio}
      src={image}
      cover={cover}
      fullWidth={fullWidth}
      hoverSrc={hoverImage}
      maxWidth={maxWidth}
      background={background}
    />
  ) : (
    <GatsbyImageComponent
      alt={alt || ""}
      location={location}
      onClick={onClick}
      ratio={ratio}
      image={image}
      fullHeight={fullHeight}
      imageLink={imageLink}
      styled={styled}
      objectFit={objectFit}
      background={background}
      staticImage={staticImage}
      loading={loading}
    />
  )
